module.exports = __webpack_public_path__ + "img/code-analyzer03.e3dca1ca.jpg";